import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import { Box, Snackbar } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy, faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { getToken } from "../Storage/Storage";

const AccessTokenModal = () => {
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState(null);
  const [enableGo, setEnableGo] = useState(false);
  const [copyEnable, setCopyEnable] = useState(false);

  const handleOpen = async () => {
    const t = await getToken(); // Fetch token
    if (t) {
      setToken(t); // Set token
      setOpen(true); // Open modal
    }
  };

  const handleClose = () => {
    setOpen(false); // Close the modal
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(token);
    setEnableGo(true);
    setCopyEnable(true);
  };

  const handleGo = () => {
    window.location.href = "/lessons"; // Navigate to lessons
  };

  useEffect(() => {
    if (copyEnable) {
      const timer = setTimeout(() => {
        setCopyEnable(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [copyEnable]);

  // Add event listener for the custom event
  useEffect(() => {
    const openModalListener = () => {
      handleOpen();
    };

    window.addEventListener("openAccessTokenModal", openModalListener);

    return () => {
      window.removeEventListener("openAccessTokenModal", openModalListener);
    };
  }, []);

  return (
    <>
      {/* Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="teacher-modal-title"
        aria-describedby="teacher-modal-description"
      >
        <Box className="teacher-modal-container">
          {/* Close Icon */}
          <button className="teacher-modal-close-icon" onClick={handleClose}>
            &times;
          </button>
          <h2 id="teacher-modal-title" className="teacher-modal-title">
            Copy Your Access Token
          </h2>
          <p className="teacher-modal-token" onClick={handleCopy}>
            {token?.slice(0, 52)}...
            <FontAwesomeIcon
              icon={!enableGo ? faCopy : faCheckCircle}
              className="teacher-modal-copy-icon"
              style={{ color: !enableGo ? "#9a9a9a" : "#4caf50" }}
            />
          </p>
          <button
            className="teacher-modal-go-btn"
            onClick={enableGo ? handleGo : null}
            disabled={!enableGo}
          >
            Go to AnaVu Web
          </button>
        </Box>
      </Modal>

      {/* Snackbar */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={copyEnable}
        message="Access Token copied to clipboard!"
        ContentProps={{
          className: "teacher-snackbar-content",
        }}
      />
    </>
  );
};

export default AccessTokenModal;

// Function to dispatch the custom event
export const openAccessTokenModal = () => {
  const event = new CustomEvent("openAccessTokenModal");
  window.dispatchEvent(event);
};
